import { useSuspenseInfiniteQuery, useSuspenseQuery } from '@tanstack/react-query'
import { useQueryKeys } from '../../../hooks/useQueryKeys'
import { cacheDuration } from '~/shared'
import { listConversationUsersQueryOptions } from '~/queries'
import { bridgeMessageToRichBlockMessage } from '~/adapters/block'
import { getApiClient } from '../../../stores'
import { ExtendedBridgeMessage } from '~/types'

export const useConversationMessages = ({
  workspaceId,
  botId,
  conversationId,
}: {
  workspaceId: string
  botId: string
  conversationId: string
}) => {
  const { listMessages } = useQueryKeys()
  const { users } = useSuspenseQuery(listConversationUsersQueryOptions({ conversationId, botId, workspaceId })).data

  return useSuspenseInfiniteQuery({
    staleTime: cacheDuration.short,
    queryKey: listMessages(workspaceId, botId, conversationId),
    queryFn: async ({ pageParam }) => {
      const { messages, meta } = await getApiClient({ workspaceId, botId })
        .listMessages({ conversationId, nextToken: pageParam })
        .catch((e: unknown) => {
          console.error('Failed to fetch events', e)
          return { messages: [], meta: { nextToken: null } }
        })

      const richBlockMessages = (messages as ExtendedBridgeMessage[]).map((message) => {
        const user = users.find((user) => user.id === message.userId)
        return bridgeMessageToRichBlockMessage(message, user)
      })

      return {
        messages: richBlockMessages,
        meta,
      }
    },
    getNextPageParam: (lastPage) => {
      return lastPage.meta.nextToken
    },
    initialPageParam: undefined as string | undefined,
  })
}
